import React from "react";
import PanelHead from "../../Panel/PanelHead";
import PanelBody from "../../Panel/PanelBody";
import { FormAddMarketer} from "./FormAddMarketer";

export const PanelAddMarketer = () => {
  return (
    <div>
      {" "}
      <PanelHead
        title={
          <div className="flex items-center justify-between w-full gap-4">
            <div>Add Marketer</div>
          </div>
        }
      />
      <PanelBody content={<FormAddMarketer />} />
    </div>
  );
};
